import { render, staticRenderFns } from "./MarketplaceLayout.vue?vue&type=template&id=6c77062a&scoped=true&"
import script from "./MarketplaceLayout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c77062a",
  null
  
)

export default component.exports